import { config } from "@/config/config";

/**
 * The root URL of the PostgREST backend.
 *
 * The generated client embeds this rather than a build-time constant, so the
 * same bundle can be pointed at a local `docker compose` instance or a
 * deployed one by changing `backendBaseUrl` alone — via `config.json` at
 * runtime, or `VITE_BACKEND_BASE_URL` at build time if `config.json` doesn't
 * set it (see `src/config/config.ts`).
 *
 * This is exported as an object with a `toString()` rather than a plain
 * string so every interpolation (e.g. `${backendBaseUrl}/vehicles` in the
 * generated calls) re-reads the current `config` value, including the
 * `config.json` overlay — which is only known once `loadRuntimeConfig()`
 * resolves, well after this module has already been imported and evaluated.
 *
 * A missing value would otherwise produce requests to `undefined/vehicles`,
 * which fail as ordinary 404s and are easy to misread as a backend problem,
 * so accessing it while unset fails loudly instead.
 */
export const backendBaseUrl = {
  toString(): string {
    if (!config.backendBaseUrl) {
      throw new Error(
        "backendBaseUrl is not set. Provide it in config.json, or copy " +
          ".env.example to .env and set VITE_BACKEND_BASE_URL, e.g. " +
          "http://localhost:3001 for the servicevault docker compose stack.",
      );
    }

    // Normalised without a trailing slash; generated routes supply their own.
    return config.backendBaseUrl.replace(/\/+$/, "");
  },
};
